<template lang="pug">
  .quotation-detail
    el-dialog(
      :visible="value"
      :title="$t('报价明细')"
      :close-on-click-modal="false"
      center
      width="900px"
      @close="$emit('input', false)"
    )
      tabs(
        :tabs="tabs"
        :index="index"
        @change="val => index = val"
      )
      el-table(
        v-loading="loading"
        :data="table.vendor_price"
      )
        el-table-column(
          min-width="130"
          :prop="isZh ? 'service_name_ch' : 'service_name'"
          :label="$t('服务类别')"
          show-overflow-tooltip
        )
        el-table-column(
          :prop="isZh ? 'service_item_name_ch' : 'service_item_name'"
          :label="$t('服务项目')"
          show-overflow-tooltip
        )
        el-table-column(
          prop="unit_price"
          :label="$t('单价')"
        )
          template(slot-scope="scope")
            span {{ scope.row.unit_price | formatMoney }}
        el-table-column(
          prop="number"
          :label="$t('数量')"
        )
          template(slot-scope="scope")
            span {{ scope.row.number | numberWithCommas }}

        el-table-column(
          prop="total_price"
          :label="$t('总价')"
          width="150"
          show-overflow-tooltip
        )
          template(slot-scope="scope")
            span {{ scope.row.total_price | formatMoney }}
        template(v-if="isIT")
          el-table-column(
            prop="solutionsName"
            :label="$t('可借助的其他现有UL解决方案')"
            align="left"
            width="280"
          )
            template(slot-scope="scope")
              span {{ scope.row.solutions_name ? scope.row.solutions_name : '—' }}
          el-table-column(
            prop="priceAfterLeveraging"
            :label="$t('借助其他解决方案后的报价')"
            align="left"
            width="220"
          )
            template(slot-scope="scope")
              span {{ scope.row.price_after_leveraging | formatMoney(2) }}
          el-table-column(
            :label="$t('持续时间')"
            align="left"
            width="310"
          )
            template(slot-scope="scope")
              span(v-if="!(scope.row.coverage_start_date && scope.row.coverage_end_date)") —
              span(v-else) {{ scope.row.coverage_start_date | formatDate }} ~ {{ scope.row.coverage_end_date | formatDate }}

        el-table-column(:label="$t('明细')")
          template(slot-scope="scope")
            uploaded-file-display(
              v-if="scope.row.download_url"
              :fileName="scope.row.file_name"
              :downloadUrl="scope.row.download_url"
              :fileNameList="scope.row.file_name_list"
              width="85px"
            )
            span(v-else) —
        el-table-column(
          prop="remark"
          :label="$t('备注')"
          show-overflow-tooltip
        )
          template(slot-scope="scope")
            span {{ scope.row.remark || '—' }}

      .quotation-detail--bottom
        div(style="color: #f66c62")
          span(v-if="!isDemoUser") {{ $t('折扣') }}:
          span -{{ table.discount | formatMoney }}
        div
          span {{ $t('小计') }}:
          span {{ table.total_price | formatMoney }}
</template>

<script>
import axios from 'axios'
import Tabs from '@/components/Tabs'
import { formatMoney, numberWithCommas, formatDate } from '@/umcc/util'
import UploadedFileDisplay from '@/components/UploadedFileDisplay'
import UploadMultipleFile from '@/components/UploadMultipleFile'
import db from '@/umcc/db'

export default {
  components: {
    Tabs,
    UploadMultipleFile,
    UploadedFileDisplay
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      isRequired: true,
      default () {
        return null
      }
    }
  },
  data () {
    return {
      index: 0,
      loading: false,
      data: []
    }
  },
  computed: {
    isDemoUser () {
      return this.$store.state.common.user.company_name === 'Mccann'
    },
    tabs () {
      if (this.loading) return []
      if (this.isZh) return this.data.map(i => `${i.category_name_ch}(${i.category_name})`)
      return this.data.map(i => i.category_name)
    },
    table () {
      return this.data[this.index] || {}
    },
    isIT () {
      return this.tabs[this.index] === 'IT(IT)'
    },
    isZh () {
      return db.lang === 'zh'
    },
    activePhaseType () {
      return this.$store.state.campaign.activePhaseType
    },
    phaseType () {
      return this.$store.state.campaign.phaseType
    }
  },
  watch: {
    value () {
      this.index = 0
    },
    id () {
      if (this.id) this.fetchData()
    }
  },
  filters: {
    formatMoney,
    numberWithCommas,
    formatDate
  },
  mounted () {
    if (this.id) this.fetchData()
  },
  methods: {
    fetchData () {
      this.loading = true
      axios.get('/management/subfinal/getVendorQuotation', {
        params: {
          sub_final_scope_vendor_id: this.id,
          phase_current: this.activePhaseType,
          phase_reality: this.phaseType
        }
      })
        .then(res => {
          if (this.$store.state.campaign.taskId == null) {
            this.$store.commit('campaign/setTaskId', res.task_id)
          }
          this.data = res.vendor_price
          this.loading = false
        })
    }
  }
}
</script>

<style lang="stylus">
.quotation-detail
  .campaign-tab
    height 45px
    top 40px

.quotation-detail--bottom > div
  text-align right
  > span
    width 70px
    padding 6px
    display inline-block
    &:last-child
      text-align left
</style>
